module.exports = __webpack_public_path__ + "static/img/kanban05.d57d0d9b.png";